import React, { FunctionComponent } from 'react';
import type { Occupation } from '../../../types/toppage';
import type { OccupationDetail } from '../../../types/toppage';

type Props = {
  occupations: Occupation[];
  occupationDetails: OccupationDetail[];
  detailsRef: React.RefObject<HTMLDetailsElement>;
  contentRef: React.RefObject<HTMLDivElement>;
  onClickSummary: (e: React.MouseEvent) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  occupations,
  occupationDetails,
  detailsRef,
  contentRef,
  onClickSummary
}) => {
  return (
    <section className="sitetop-recruitment">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          OCCUPATION<span className="sitetop-pickup-sub">職種から探す</span>
        </h2>
      </div>
      <div className="sitetop-location-container">
        <nav className="sitetop-occupation-items">
          {occupations.map((occupation) => (
            <a
              key={occupation.id}
              href={'/' + occupation.path}
              className="sitetop-occupation-items-parent-word"
              data-event="click"
              data-category="topcontent"
              data-value="from_occupations"
            >
              {occupation.name} ({occupation.count})
            </a>
          ))}
        </nav>
        <details className="sitetop-occupation-details" ref={detailsRef}>
          <summary className="sitetop-occupation-details-title" onClick={onClickSummary}>もっと見る</summary>
          <div ref={contentRef}>
            <nav className="sitetop-occupation-items">
              {occupationDetails.map((occupationDetail) => {
                const occupation = occupations.find((occ) => occ.path === occupationDetail.occupation_path);
                return (
                  <a
                    key={occupationDetail.id}
                    href={'/' + occupationDetail.occupation_path + '/' + occupationDetail.path}
                    className="sitetop-occupation-items-parent-word"
                    data-event="click"
                    data-category="topcontent"
                    data-value="from_occupation_details"
                  >
                    {occupation?.name || ''} ＞ {occupationDetail.name} ({occupationDetail.count})
                  </a>
                );
              })}
            </nav>
          </div>
        </details>
      </div>
    </section>
  );
};
